var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    transform: "matrix(-1 0 0 1 125 25)",
    fill: "#EB001B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 55.5,
    cy: 55.5,
    r: 54,
    transform: "matrix(-1 0 0 1 130 20)",
    stroke: "#EB001B",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1194,
    cy: 19.0999,
    r: 5.9129,
    fill: "#EB001B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.1968,
    cy: 16.3709,
    r: 3.18387,
    fill: "#EB001B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.829,
    cy: 40.9324,
    r: 3.18387,
    fill: "#EB001B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5484,
    cy: 73.2256,
    r: 4.54839,
    fill: "#EB001B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8226,
    cy: 113.706,
    r: 3.18387,
    fill: "#EB001B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9226,
    cy: 134.174,
    r: 4.54839,
    fill: "#EB001B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.0323,
    cy: 136.903,
    r: 1.81935,
    fill: "#EB001B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.1387,
    cy: 141.907,
    r: 4.09355,
    fill: "#EB001B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.606,
    cy: 135.994,
    r: 2.72903,
    fill: "#EB001B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.623,
    cy: 125.532,
    r: 4.09355,
    fill: "#EB001B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.99,
    cy: 106.429,
    r: 2.27419,
    fill: "#EB001B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.177,
    cy: 89.1453,
    r: 2.27419,
    fill: "#EB001B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.903,
    cy: 55.0323,
    r: 4.54839,
    fill: "#EB001B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.168,
    cy: 49.5742,
    r: 2.72903,
    fill: "#EB001B"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.245,
    cy: 25.0127,
    r: 2.72903,
    fill: "#EB001B"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7742,
    cy: 7.72903,
    r: 2.72903,
    fill: "#EB001B"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.529,
    cy: 18.6451,
    r: 4.54839,
    fill: "#EB001B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0312 99.9062C57.5729 99.9062 57.2188 99.7604 56.9688 99.4688C56.7188 99.1771 56.5938 98.8125 56.5938 98.375C56.5938 97.9375 56.7292 97.5104 57 97.0938L70.4688 75.5L56.4375 54.8125C56.1458 54.3958 56 53.9792 56 53.5625C56 53.125 56.125 52.7604 56.375 52.4688C56.6458 52.1562 57.0104 52 57.4688 52H62.25C63 52 63.5312 52.1667 63.8438 52.5C64.1771 52.8333 64.4479 53.1667 64.6562 53.5L74.875 69.8125L84.5312 53.5C85.0312 52.5 85.8125 52 86.875 52H91.5312C91.9896 52 92.3438 52.1458 92.5938 52.4375C92.8646 52.7292 93 53.0938 93 53.5312C93 53.9479 92.875 54.3542 92.625 54.75L79.4688 75.3125L94.3438 97.0938C94.6146 97.5104 94.75 97.9375 94.75 98.375C94.75 98.7917 94.625 99.1562 94.375 99.4688C94.125 99.7604 93.7708 99.9062 93.3125 99.9062H88.4688C87.7604 99.9062 87.2396 99.7396 86.9062 99.4062C86.5938 99.0729 86.3333 98.7396 86.125 98.4062L75.0625 81.3438L64.75 98.4062C64.5417 98.7396 64.2708 99.0729 63.9375 99.4062C63.625 99.7396 63.0938 99.9062 62.3438 99.9062H58.0312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.6eba12b1626bc2ccc18500d1425beef9.svg";
export { ForwardRef as ReactComponent };